<template>
  <main-layout :selectedMenu="'myHome'">
    <div class="container containerManageCenter">
      <asideCom :activityIndex="0"></asideCom>
      <div class="content">
        <div class="top-choose">
          <div class="choose" v-if="contentIndex === 0">
            {{ $t("global.个人资料") }}
          </div>

          <div class="choose" v-if="contentIndex === 1">
            {{ $t("global.账号安全") }}
          </div>
        </div>

        <div class="my-message-c" v-if="contentIndex === 0">
          <div class="basic-message">
            <div class="headview padd30">
              <div class="upcontent">
                <div class="upcontent1">
                  <cropImg
                    ref="cropComponent"
                    :dialogWidth="dialogWidth"
                    :dialogHeight="dialogHeight"
                    :cropWidth="cropWidth"
                    :cropHeight="cropHeight"
                    :minWidth="minWidth"
                    :minHeight="minHeight"
                    :showtext="showText"
                    :fixed="fixed"
                    :fixedBox="fixedBox"
                    :fixedNumber="fixedNumber"
                    :original="original"
                    @update-img="updateImage"
                    :is-upload="avatar == '' || isUpload"
                  ></cropImg>

                  <div
                    style="width: 100%; height: 118px; text-align: center"
                    class="endcroping"
                    v-show="avatar != ''"
                  >
                    <img
                      :src="
                        avatar
                          | imageUrl(
                            '/static/profile_img_default.png',
                            180,
                            180
                          )
                      "
                    />
                  </div>
                  <span
                    class="change"
                    style="color: #2026cc; cursor: pointer"
                    @click="reUpload"
                    v-show="avatar != ''"
                    >{{ $t("global.修改头像") }}</span
                  >
                </div>
              </div>
            </div>

            <div class="contain padd30">
              <div class="userinformation">
                {{ $t("global.基本信息") }}
                <span class="inforsub" @click="modifyInfo">{{
                  $t("global.保存")
                }}</span>
              </div>
              <div class="bindstyle">
                <div class="font">{{ $t("global.手机号") }}</div>
                <p v-if="phone">{{ phone && phone | accountCut("phone") }}</p>
                <div v-else>
                  <a href="/manageCenter?step=1">{{ $t("global.去绑定") }}</a>
                  <span>{{ $t("global.仅自己可见") }}</span>
                </div>
              </div>

              <div class="bindstyle mt20">
                <div class="font">{{ $t("global.邮箱") }}</div>
                <p v-if="email">{{ email && email | accountCut("email") }}</p>
                <div v-else>
                  <a href="/manageCenter?step=1">{{ $t("global.去绑定") }}</a>
                  <span>{{ $t("global.仅自己可见") }}</span>
                </div>
              </div>

              <div class="left mt20">
                <div class="font">
                  <span class="tips">*</span>
                  {{ $t("global.昵称") }}
                </div>
                <input
                  type="text"
                  v-model.trim="nickname"
                  @blur="testValue($event, 0)"
                  class="real-name"
                  :placeholder="$t('global.请填写昵称')"
                />
              </div>

              <div class="mt20">
                <div class="font">
                  <span class="tips"></span>
                  {{ $t("global.真实姓名") }}
                </div>
                <input
                  type="text"
                  :placeholder="$t('global.请填写真实姓名')"
                  v-model="name"
                />
              </div>
              <div class="sexchecked mt20">
                <div class="font">
                  <span class="tips">*</span>
                  {{ $t("global.性别") }}
                </div>
                <input
                  type="radio"
                  name="sex"
                  id="mansex"
                  :checked="gender == 1"
                  @click="gender = 1"
                />
                <label for="mansex">{{ $t("global.男") }}</label>
                <input
                  type="radio"
                  name="sex"
                  id="womensex"
                  :checked="gender == 2"
                  @click="gender = 2"
                />
                <label for="womensex">{{ $t("global.女") }}</label>
              </div>

              <div class="userbirthday mt20">
                <div class="font">{{ $t("global.生日") }}</div>
                <el-date-picker
                  v-model="birthday"
                  ref="datapicker"
                  value-format="yyyy-MM-dd"
                  type="date"
                  :placeholder="$t('global.选择日期')"
                ></el-date-picker>
              </div>
            </div>

            <div class="contain padd30 mt30">
              <div class="left">
                <div class="font" style="margin-top: 15px">
                  <span class="tips">*</span>
                  {{ $t("global.所在地") }}
                </div>
                <el-select
                  v-model="country"
                  filterable
                  @change="resetArea"
                  :placeholder="$t('project.请搜索或选择国家')"
                >
                  <el-option
                    :label="language === 'zh' ? item.zh : item.en"
                    :value="item.id"
                    v-for="item in countryOptions"
                    :key="item.id"
                  ></el-option>
                </el-select>
                <el-select
                  v-model="area"
                  filterable
                  :placeholder="$t('global.请选择城市')"
                >
                  <el-option
                    :label="language === 'zh' ? item.zh : item.en"
                    :value="item.id"
                    v-for="item in cityOptions"
                    :key="item.id"
                  ></el-option>
                </el-select>

                <div>
                  <div class="font mt20" style="margin-top: 0">
                    {{ $t("global.国籍") }}
                  </div>
                  <div class="special mt20">
                    <el-select
                      v-model="nationality"
                      filterable
                      :placeholder="$t('video.请搜索或选择国籍')"
                      @change="testValue($event, 6)"
                      class="elselect"
                    >
                      <el-option
                        v-for="(item, index) in countryOptions"
                        :key="index"
                        :label="language === 'zh' ? item.zh : item.en"
                        :value="language === 'zh' ? item.zh : item.en"
                      ></el-option>
                    </el-select>
                  </div>
                </div>
              </div>

              <div class="right mt20">
                <div class="font">{{ $t("global.职业") }}</div>
                <input
                  type="text"
                  v-model="career"
                  class="real-name"
                  @blur="testValue($event, 3)"
                  :placeholder="$t('global.请输入职业')"
                />
              </div>
              <div class="right mt20">
                <div class="font">
                  <!-- <span class="tips">*</span> -->
                  {{ $t("global.个性签名") }}
                </div>
                <input
                  class="peopleDT"
                  v-model.trim="signature"
                  :placeholder="$t('global.请输入个性签名')"
                  @change="testValue($event, 10)"
                />
              </div>

              <div class="left mt20">
                <div class="font">
                  <span class="tips">*</span>
                  {{ $t("global.个人简介") }}
                </div>
                <textarea
                  class="peopleDT userJD"
                  v-model.trim="introduce"
                  :placeholder="$t('global.请输入个人介绍')"
                  @change="testValue($event, 9)"
                ></textarea>
              </div>

              <div class="left mt20">
                <div class="font">
                  {{ $t("global.个人简介") }}({{ $t("global.英文") }})
                </div>
                <textarea
                  class="peopleDT userJD"
                  v-model="enIntroduce"
                  :placeholder="$t('global.请输入个人介绍')"
                  @change="testValue($event, 9)"
                ></textarea>
              </div>

              <div class="usercreation mt20">
                <div class="font">
                  <span class="tips">*</span>
                  {{ $t("global.创作领域") }}
                </div>
                <div class="userstyle">
                  <span
                    v-for="(item, index) in fieldList"
                    @click="changeEquipmentIds(item)"
                    :class="{ active: isSelectOne(item, field) }"
                    :key="index"
                    >{{ item }}</span
                  >

                  <a class="clickaddtitle" @click="addEquipment = true">{{
                    $t("global.新增")
                  }}</a>
                  <template v-if="addEquipment">
                    <div class="userinfortit">
                      <input
                        type="text"
                        v-model="newEquipment"
                        maxlength="30"
                        :placeholder="$t('global.输入标签')"
                      />
                      <a @click="saveIndustry()">{{ $t("global.确定") }}</a>
                    </div>
                  </template>
                </div>
              </div>
            </div>
          </div>

          <div class="contain bordertps educations">
            <div>
              <div class="userinformation">
                {{ $t("global.教育背景") }}
                <span class="inforsub" @click="educationSave">{{
                  $t("global.保存")
                }}</span>
              </div>
              <div class="font">{{ $t("global.学校名称") }}</div>
              <input
                type="text"
                v-model="school"
                class="real-name"
                :placeholder="$t('global.请输入院校')"
              />
              <select class="selchecked" v-model="isGraduation">
                <option value="1">{{ $t("global.已毕业") }}</option>
                <option value="2">{{ $t("global.在读") }}</option>
              </select>
            </div>
          </div>

          <div class="contain bordertps educations">
            <div>
              <div class="userinformation">
                {{ $t("global.联系方式") }}
                <span class="inforsub" @click="concatSave">{{
                  $t("global.保存")
                }}</span>
              </div>
              <div class="wecharcode">
                <div class="font">{{ $t("global.微信") }}</div>
                <input
                  type="text"
                  :placeholder="$t('global.请填写微信号')"
                  v-model="wechatLink"
                />
                <select class="selchecked" v-model="wechatVisible">
                  <option value="2">{{ $t("global.仅自己可见") }}</option>
                  <option value="3">{{ $t("global.所有人") }}</option>
                </select>
              </div>

              <div class="wecharcode">
                <div class="font">QQ</div>
                <input
                  type="text"
                  :placeholder="$t('global.请填写QQ号')"
                  v-model="qqLink"
                />
                <select class="selchecked" v-model="qqVisible">
                  <option value="4">{{ $t("global.仅自己可见") }}</option>
                  <option value="5">{{ $t("global.所有人") }}</option>
                </select>
              </div>
            </div>
          </div>

          <!--   user links   -->
          <div class="contain bordertps">
            <div class="left">
              <div class="userinformation">
                {{ $t("global.个人链接") }}
                <span class="inforsub" @click="linkSave">{{
                  $t("global.保存")
                }}</span>
              </div>
              <div class="linkItem">
                <span class="linkTitle">{{ $t("global.个人网站") }}</span>
                <input
                  type="text"
                  v-model="homeLink"
                  class="linkInput"
                  placeholder="https://www.manamana.net"
                />
              </div>
              <div class="linkItem">
                <span class="linkTitle">{{ $t("global.新浪微博") }}</span>
                <input
                  type="text"
                  v-model="weiboLink"
                  class="linkInput"
                  placeholder="https://weibo.com/example"
                />
              </div>
              <div class="linkItem">
                <span class="linkTitle">Instagram</span>
                <input
                  type="text"
                  v-model="instagramLink"
                  class="linkInput"
                  placeholder="https://www.instagram.com/xxx"
                />
              </div>
              <div class="linkItem">
                <span class="linkTitle">Facebook</span>
                <input
                  type="text"
                  v-model="facebookLink"
                  class="linkInput"
                  placeholder="https://www.facebook.com/xxx"
                />
              </div>
              <div class="linkItem">
                <span class="linkTitle">Twitter</span>
                <input
                  type="text"
                  v-model="twitterLink"
                  class="linkInput"
                  placeholder="https://www.twitter.com/xxx"
                />
              </div>
            </div>
          </div>
          <div class="cancellation" @click="gotoCancel">
            <div class="butBox">{{$t('works.注销账号')}}<img src="https://image.manamana.net/1635298463000_zpmDBACR" alt=""></div>
          </div>
        </div>

        <div class="modify-password-content" v-if="contentIndex === 1">
          <div class="account_info">
            <h4>{{ $t("global.账号信息") }}</h4>
            <ul class="list">
              <li>
                <span class="title">{{ $t("global.手机号") }}</span>
                <span class="has_value" v-if="phone">{{
                  phone | accountCut("phone")
                }}</span>
                <span v-else class="no_value">{{ $t("global.未绑定") }}</span>
                <el-button
                  type="primary"
                  @click="bind('phone')"
                  v-if="!phone"
                  size="small"
                  >{{ $t("global.绑定") }}</el-button
                >
                <el-button @click="bind('phone', phone)" v-else size="small">{{
                  $t("global.修改")
                }}</el-button>
              </li>
              <li>
                <span class="title">{{ $t("global.邮箱") }}</span>
                <span class="has_value" v-if="email">{{
                  email | accountCut("email")
                }}</span>
                <span v-else class="no_value">{{ $t("global.未绑定") }}</span>
                <el-button
                  type="primary"
                  @click="bind('email')"
                  v-if="!email"
                  size="small"
                  >{{ $t("global.绑定") }}</el-button
                >
                <el-button @click="bind('email', email)" v-else size="small">{{
                  $t("global.修改")
                }}</el-button>
              </li>
              <li>
                <span class="title">{{ $t("global.登录密码") }}</span>
                <span class="has_value">*******</span>
                <el-button @click="bind('password')" size="small">{{
                  $t("global.修改")
                }}</el-button>
              </li>
            </ul>
          </div>
          <div class="third_info">
            <h4>{{ $t("global.第三方账号绑定") }}</h4>
            <ul class="list">
              <li>
                <span class="title">{{ $t("global.微信") }}</span>
                <span class="has_value" v-if="wechatBind">{{
                  wechatBind.nickname
                }}</span>
                <span v-else class="no_value">{{ $t("global.未绑定") }}</span>
                <el-button
                  type="primary"
                  @click="bindThirdParty('wechatBind')"
                  v-if="!wechatBind"
                  size="small"
                  >{{ $t("global.绑定") }}</el-button
                >
                <el-button @click="unBind('wechat')" v-else size="small">{{
                  $t("global.解绑")
                }}</el-button>
              </li>
              <li>
                <span class="title">{{ $t("global.微博") }}</span>
                <span class="has_value" v-if="weiboBind">{{
                  weiboBind.nickname
                }}</span>
                <span v-else class="no_value">{{ $t("global.未绑定") }}</span>
                <el-button
                  type="primary"
                  @click="bindThirdParty('weiboBind')"
                  v-if="!weiboBind"
                  size="small"
                  >{{ $t("global.绑定") }}</el-button
                >
                <el-button @click="unBind('weibo')" v-else size="small">{{
                  $t("global.解绑")
                }}</el-button>
              </li>
              <li>
                <span class="title">QQ</span>
                <span class="has_value" v-if="qqBind">{{
                  qqBind.nickname
                }}</span>
                <span v-else class="no_value">{{ $t("global.未绑定") }}</span>
                <el-button
                  type="primary"
                  @click="bindThirdParty('qqBind')"
                  v-if="!qqBind"
                  size="small"
                  >{{ $t("global.绑定") }}</el-button
                >
                <el-button @click="unBind('qq')" v-else size="small">{{
                  $t("global.解绑")
                }}</el-button>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <BindDialog
      :type="BindDialogType"
      :argument="argument"
      v-if="showDialog"
      @close="handleClose"
      @confirm="confirm"
    />
    <service></service>
  </main-layout>
</template>

<script type="text/ecmascript-6">
import MainLayout from "@/layouts/MainLayout";
import service from "@/components/service.vue";
import asideCom from "@/components/aside.vue";
import vueCropper from "@/assets/lib/vue-cropper";
import cropImg from "@/components/CropImg.vue";
import BindDialog from "@/pages/dialog/BindDialog";
import * as qiniu from "qiniu-js";

export default {
  name: "manageCenter",
  metaInfo() {
    return {
      title: this.$t("global.用户中心") + " | MANA",
    };
  },
  data() {
    return {
      returnUrl: this.$route.query.redirecturl,
      dialogWidth: 300,
      dialogHeight: 300,
      cropWidth: 180,
      cropHeight: 180,
      minWidth: 180,
      minHeight: 180,
      countryOptions: [],
      cityOptions: [],
      fixed: true,
      fixedNumber: [1, 1],
      fixedBox: false,
      original: false,
      //dialog
      showDialog: false,
      BindDialogType: 1,
      argument: { hasOldValue: false, title: this.$t("global.绑定手机号") },
      showChangePassword: false,
      equipment: [],
      newEquipment: "",
      addEquipment: false,
      equipmentIds: [],

      isUpload: false,
      showText: true,
      contentIndex: 0,
      options: "",
      phone: "",
      email: "",
      avatar: "",
      file: "",
      nickname: "",
      career: "",
      school: "",
      isGraduation: "",
      gender: "",
      birthday: "",
      country: "",
      nationality: "",
      area: "",
      field: "",
      introduce: "",
      enIntroduce: "",
      signature: "",
      fieldList: [],
      form: {
        newPassword: "",
        confirmPassword: "",
      },
      rules: {
        oldPassword: [
          {
            required: true,
            message: this.$t("global.密码不能为空"),
            trigger: "blur",
          },
        ],
        newPassword: [
          {
            required: true,
            message: this.$t("global.密码不能为空"),
            trigger: "blur",
          },
          { min: 7, message: "密码不少于7位，且不能为纯数字", trigger: "blur" },
        ],
      },
      contentTab: [
        this.$t("global.基本信息"),
        this.$t("global.密码修改"),
        this.$t("global.邮箱修改"),
      ],
      weiboLink: "",
      qqLink: "",
      wechatLink: "",
      wechatVisible: "",
      qqVisible: "",
      facebookLink: "",
      twitterLink: "",
      instagramLink: "",
      homeLink: "",
      websit: "",
      previews: {},
      imgUrl: "",
      name: "",
      wechatBind: false,
      weiboBind: false,
      qqBind: false,
    };
  },
  components: {
    MainLayout,
    service,
    asideCom,
    vueCropper,
    cropImg,
    BindDialog,
  },
  computed: {
    peopleMessage() {
      return this.$store.state.peopleMessage;
    },
    language() {
      return this.$language();
    },
  },
  watch: {
    $route() {
      if (this.$route.query.step) {
        this.contentIndex = 1;
      } else {
        this.contentIndex = 0;
      }
    },
    equipmentIds() {
      if (this.equipmentIds.length > 3) {
        this.$message(this.$t("global.创作领域最多只能选三个"));
        this.equipmentIds.splice(this.equipmentIds.length - 1, 1);
      }
    },
    country(value) {
      if (value || value === 0) {
        this.getCity(value);
      }
    },
  },
  created() {
    this.contentIndex = +this.$route.query.step || 0;
    this.getArea();
    this.getFieldList();
    this.getInfo();
    this.getCountry();
  },
  methods: {
    resetArea() {
      this.area = "";
    },
    getCountry() {
      this.$http.get("/api/mobile/area/getCountry").then((res) => {
        if (res.code === "OK") {
          const data = res.data;
          Object.keys(data).filter((item) => {
            this.countryOptions = [...this.countryOptions, ...data[item]];
          });
          if (this.language === "zh") {
            this.countryOptions.unshift({
              city: [],
              en: "China",
              id: 0,
              py: "People's Republic of China",
              pyf: "P",
              value: "",
              zh: "中国",
            });
          }
        }
      });
    },
    getFieldList() {
      this.$http.get("/api/mobile/u/fieldList").then((res) => {
        if (res.code === "OK") {
          this.fieldList = [
            ...new Set([
              ...this.fieldList,
              ...res.data.map((item) =>
                this.language === "zh" ? item.title : item.titleEn
              ),
            ]),
          ];
        }
      });
    },
    getCity(id) {
      this.$http
        .get(`/api/mobile/area/getCityByCountryId?countryId=${id}`)
        .then((res) => {
          if (res.code === "OK") {
            this.cityOptions = res.data;
          }
        });
    },
    unBind(type) {
      this.$confirm(
        `${this.$t("global.确定解绑")}${
          type === "wechat"
            ? this.$t("global.微信")
            : type === "weibo"
            ? this.$t("global.微博")
            : type === "qq"
            ? "QQ"
            : null
        }?`,
        this.$t("global.提示"),
        {
          confirmButtonText: this.$t("global.确定"),
          cancelButtonText: this.$t("global.取消"),
          type: "warning",
        }
      )
        .then(() => {
          const url = `/api/user/b/unThirdBinding`;
          const params = {
            unBindType: type,
          };
          this.$http.post(url, params).then((res) => {
            if (res.code === "OK") {
              this.getInfo();
              this.$message({
                type: "success",
                message: this.$t("global.解绑成功"),
              });
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: this.$t("global.已取消解绑"),
          });
        });
    },
    handleClose() {
      this.getInfo();
      this.showDialog = false;
    },
    confirm() {
      this.getInfo();
      this.showDialog = false;
      if (window.history.length > 1 && this.returnUrl) {
        this.$router.back(-1);
      } else if (this.returnUrl) {
        window.location.href = this.returnUrl;
      }
    },
    bind(type, old) {
      this.showDialog = true;
      this.BindDialogType =
        type === "phone"
          ? 1
          : type === "email"
          ? 2
          : type === "password"
          ? 3
          : null;
      this.argument = {
        oldPhoneOrEmail: old,
        title:
          this.BindDialogType === 1
            ? old
              ? this.$t("global.修改手机号")
              : this.$t("global.绑定手机号")
            : this.BindDialogType === 2
            ? old
              ? this.$t("global.修改邮箱")
              : this.$t("global.绑定邮箱")
            : this.BindDialogType === 3
            ? this.$t("global.修改密码")
            : null,
      };
      const url = `/api/user/b/binding`;
      const params = {
        type: type === "phone" ? 1 : 2,
        oldPhoneOrEmail: old ? old : undefined,
      };
    },
    realTime(data) {
      this.previews = data;
      this.$refs.cropper.getCropData((data) => {
        this.imgUrl = data;
      });
    },
    testValue(envent, valueS) {
      let reg = /\S/;
      let phonereg = /^[1][0-9]{10}$/;
      let value = "";
      switch (valueS) {
        case 0:
          if (!this.nickname) {
            this.$message.error(this.$t("global.请输入昵称"));
          }
          break;
        case 7:
          if (!this.area) {
            this.$message.error(this.$t("global.请输入联系地址"));
          }
          break;
        case 9:
          if (!this.introduce) {
            this.$message.error(this.$t("global.请输入个人简介"));
          } else if (this.introduce.length > 2000) {
            this.$message.error(this.$t(`global.个人介绍不能超过2000字`));
          }
          break;
        case 10:
          let target = envent.currentTarget;
          let value = target.value;
          if (!reg.test(value)) {
            this.$message({
              message: this.$t("global.输入框不能为空"),
              type: "error",
            });
            target.classList.add("error");
          } else {
            target.classList.remove("error");
          }
          if (this.signature.length > 100) {
            this.$message.error(
              `${this.$t("global.个性签名不能超过")}100${this.$t("global.字")}`
            );
          }
          break;
        default:
          break;
      }
    },
    changeIndex(index) {
      this.contentIndex = index;
      if (index === 1) {
        this.$router.replace("/manageCenter?step=1");
      } else {
        this.$router.replace("/manageCenter");
      }
    },
    getArea() {
      this.$http.get("/api/common/country/list").then((response) => {
        this.options = response.data;
        this.$store.dispatch("setArea", response.data);
      });
    },
    gotoCancel() {
      this.$router.push('/cancel')
    },
    getInfo() {
      let auth_token = localStorage.getItem("auth_token");
      if (auth_token) {
        this.$http.get("/api/customer/info/get").then((response) => {
          if (response.code !== "ServiceError") {
            let data = response.data;
            this.$store.dispatch("setPeopleMessage", data);
            this.name = data.name;
            this.wechatBind = data.wechatBind;
            this.weiboBind = data.weiboBind;
            this.qqBind = data.qqBind;
            this.phone = data.phone;
            this.email = data.email;
            this.nickname = data.nickname;
            this.avatar = data.avatar;
            this.phone = data.phone;
            this.career = data.career;
            this.school = data.school;
            this.gender = data.gender;
            this.birthday = data.birthday;
            this.country = +data.country;
            this.nationality = data.nationality;
            this.area = +data.area;
            this.field = data.field
              .split(",")
              .filter((item) => item && item.trim() != "");
            this.fieldList = [...new Set([...this.fieldList, ...this.field])];
            this.isGraduation = data.isGraduation;
            this.wechatLink = data.wechatLink;
            this.wechatVisible = data.wechatVisible;
            this.qqLink = data.qqLink;
            this.qqVisible = data.qqVisible;

            this.introduce = data.introduce;
            this.enIntroduce = data.enIntroduce;
            this.signature = data.signature;
            (this.weiboLink = data.weiboLink),
              (this.homeLink = data.homeLink),
              (this.facebookLink = data.facebookLink),
              (this.twitterLink = data.twitterLink),
              (this.instagramLink = data.instagramLink);
          } else {
            this.loginout();
          }
        });
      } else {
        this.loginout();
      }
    },
    loginout() {
      localStorage.removeItem("auth_token");
      localStorage.removeItem("isLogin");
      localStorage.removeItem("userId");
      this.$store.dispatch("restUser");
      localStorage.setItem("isLogin", "false");
      if (location.pathname === "/manageCenter") {
        location.assign(`${location.origin}`);
      } else {
        location.reload();
      }
    },
    upImg(e) {
      let param = new FormData();
      param.append("files", e.target.files[0]);
      this.$http
        .post("/api/common/upload/image", param, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          this.$message({
            message: response.message,
            type: "success",
          });
          this.avatar = response.data;
          this.$store.dispatch("setPeopleMessage", {
            ...this.$store.state.peopleMessage,
            uploadImg: response.data,
          });
        });
    },
    changeInput() {
      document.getElementById("upHeadIMG").click();
    },
    modifyInfo() {
      if (!this.nickname) {
        this.$message.error(this.$t("global.请输入昵称"));
        return;
      }
      if (!this.gender) {
        this.$message.error(this.$t("global.请选择性别"));
        return;
      }
      if (!this.introduce) {
        this.$message.error(this.$t("global.请输入个人简介"));
        return;
      }
      if (this.introduce.length > 2000) {
        this.$message.error(
          `${this.$t("global.个人简介不能超过")}2000${this.$t("global.字")}`
        );
        return;
      }
      if (this.enIntroduce.length > 2000) {
        this.$message.error(
          `${this.$t("global.个人简介不能超过")}2000${this.$t("global.字")}`
        );
        return;
      }
      if (!this.field.length) {
        this.$message.error(this.$t("global.请填写创作领域"));
        return;
      }
      if ((!this.country && this.country !== 0) || !this.area) {
        this.$message.error(this.$t("global.请选择所在地"));
        return;
      }
      let user = {
        phone: this.phone,
        email: this.email,
        name: this.name,
        nickname: this.nickname,
        career: this.career,
        school: this.school,
        gender: this.gender,
        birthday: this.birthday,
        nationality: this.nationality,
        area: this.area,
        country: this.country,
        field: this.field.join(","),
        introduce: this.introduce,
        enIntroduce: this.enIntroduce,
        signature: this.signature,
      };
      this.$http.post("/api/u/info/basic/save", user).then((response) => {
        if (response.code === "OK") {
          this.$message({
            message: response.message,
            type: "success",
          });
          this.$store.dispatch("setPeopleMessage", {
            ...this.$store.state.peopleMessage,
            ...user,
          });
          this.getInfo();
        }
      });
    },
    educationSave() {
      let edu = {
        school: this.school,
        isGraduation: this.isGraduation,
      };

      this.$http.post("/api/u/info/School/save", edu).then((response) => {
        if (response.code === "OK") {
          this.$message({
            message: response.message,
            type: "success",
          });
          this.$store.dispatch("setPeopleMessage", {
            ...this.$store.state.peopleMessage,
            ...edu,
          });
        } else {
          this.$message({
            message: response.message,
            type: "error",
          });
        }
      });
    },
    concatSave() {
      let con = {
        wechatLink: this.wechatLink,
        wechatVisible: this.wechatVisible,
        qqLink: this.qqLink,
        qqVisible: this.qqVisible,
      };
      this.$http.post("/api/u/info/ContactWay/save", con).then((response) => {
        if (response.code === "OK") {
          this.$message({
            message: response.message,
            type: "success",
          });
          this.$store.dispatch("setPeopleMessage", {
            ...this.$store.state.peopleMessage,
            ...con,
          });
        } else {
          this.$message({
            message: response.message,
            type: "error",
          });
        }
      });
    },

    linkSave() {
      const reg = /^http(s?):\/\//;
      const arr = [];
      if (this.weiboLink && !reg.test(this.weiboLink)) {
        arr.push("$t('global.新浪微博')");
      }
      if (this.facebookLink && !reg.test(this.facebookLink)) {
        arr.push("Facebook");
      }
      if (this.twitterLink && !reg.test(this.twitterLink)) {
        arr.push("Twitter");
      }
      if (this.instagramLink && !reg.test(this.instagramLink)) {
        arr.push("Instagram");
      }
      if (this.homeLink && !reg.test(this.homeLink)) {
        arr.push(this.$t("global.个人网站"));
      }
      if (arr.length) {
        this.$message({
          message: `${this.$t("global.请按规范填写以下信息")}:${arr.join(",")}`,
          type: "error",
        });
        return;
      }
      let link = {
        weiboLink: this.weiboLink.trim(),
        facebookLink: this.facebookLink.trim(),
        twitterLink: this.twitterLink.trim(),
        instagramLink: this.instagramLink.trim(),
        homeLink: this.homeLink.trim(),
      };
      this.$http.post("/api/u/info/Persional/save", link).then((response) => {
        this.$message({
          message: response.message,
          type: "success",
        });
      });
    },

    modifyPassword() {
      this.$http
        .post("/api/u/password/change", {
          oldPassword: this.form.oldPassword,
          newPassword: this.form.newPassword,
          confirmPassword: this.form.confirmPassword,
        })
        .then((response) => {
          this.$message({
            message: response.message,
            type: "success",
          });
        });
    },
    modifyAvatar(avatar) {
      this.$http
        .post("/api/u/changeAvatar", {
          avatar: avatar,
        })
        .then((response) => {
          this.$message({
            message: response.message,
            type: "success",
          });
          this.avatar = avatar;
          this.$store.dispatch("setPeopleMessage", {
            ...this.$store.state.peopleMessage,
            avatar,
          });
        });
    },
    modifyEmail() {
      let emailreg =
        /^([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,3}$/;
      if (!emailreg.test(this.email)) {
        this.$message({
          message: this.$t("global.邮箱格式不正确"),
          type: "warning",
        });
        return;
      }
      this.$http
        .post("/api/u/email/change", {
          email: this.email,
        })
        .then((response) => {
          this.$message({
            message: `${this.$t("global.邮件发送成功")}，${this.$t(
              "global.请及时查看邮件"
            )}！`,
            type: "success",
          });
          localStorage.removeItem("auth_token");
          this.$router.push("/login");
        });
    },

    reUpload() {
      this.$refs.cropComponent.reUpload("3size");
    },
    updateImage(img) {
      let $this = this;
      this.imgUrl = img.data;
      let imgFile = this.$jsonUtils.base64ToFile(this.imgUrl, "a.png");
      //上传截取图片
      // if (imgFile.size / 1024 / 1024 > 3) {
      //   this.$message.error(`${this.$t("global.上传图片大小不能超过")} 3MB!`);
      //   return;
      // }
      var observable;
      var subscription;
      var error = function (err) {
        $this.uploadMessage = $this.$t("global.上传失败");
      };
      var complete = function (res) {
        $this.uploadMessage = $this.$t("global.上传成功");
        $this.modifyAvatar(res.key);
      };

      var next = function (response) {};

      var subObject = {
        next: next,
        error: error,
        complete: complete,
      };

      var config = {
        useCdnDomain: true,
        region: null,
        domain: "https://image.manamana.net",
        forceDirect: true,
      };
      var putExtra = {
        fname: imgFile.name,
        params: {},
        mimeType: null,
      };
      this.$http.get("/api/common/upload/image/token").then((res) => {
        observable = qiniu.upload(
          imgFile,
          Date.parse(new Date()) + "_" + this.$jsonUtils.randomLetter(8),
          res.message,
          putExtra,
          config
        );
        subscription = observable.subscribe(subObject);
      });
      // let param = new FormData();
      // param.append("files", imgFile);
      // param.append("fileNames", "avatar");
      // // param.append("deleteNames", this.avatar);

      // this.$http
      //   .post("/api/common/upload/images", param, {
      //     headers: {
      //       "Content-Type": "multipart/form-data"
      //     }
      //   })
      //   .then(response => {
      //     if (response.code === "OK") {
      //       this.modifyAvatar(response.data.avatar.key);
      //     } else {
      //       this.$message({
      //         message: response.message,
      //         type: "error"
      //       });
      //     }
      //   });
    },
    saveIndustry(type) {
      if (!this.fieldList.includes(this.newEquipment)) {
        this.fieldList.push(this.newEquipment);
        this.addEquipment = false;
        this.field.push(this.newEquipment);
      } else {
        this.$message({
          message: this.$t("global.该标签已存在"),
          type: "error",
        });
      }
    },
    changeEquipmentIds(id) {
      let index = this.field.indexOf(id);
      if (index == -1) {
        this.field.push(id);
      } else {
        this.field.splice(index, 1);
      }
    },
    isSelectOne(item, list) {
      let index = list.indexOf(item);
      if (index != -1) {
        return true;
      } else {
        return false;
      }
    },
    bindThirdParty(name) {
      this.$http.get("/api/passport/" + name).then((res) => {
        if (res.code === "OK") {
          window.open(res.data, "_blank");
          // location.href = res.data;
        }
      });
    },
  },
};
</script>
<style lang="stylus">
.el-select .el-input__inner {
  cursor: auto;
}

.el-button--primary {
  background-color: #2026cc;
  border-color: #2026cc;
}
</style>
<style lang="stylus" rel="stylesheet/stylus" scoped>
.el-select {
}

.my-message-c {
  background: #FFFFFF;
  border: 1px solid #E0E0E0;
}

.basic-message {
  padding-top: 0.2rem;
}

.account_info, .third_info {
  padding-top: 40px;

  h4 {
    font-size: 18px;
    font-family: PingFangSC-Semibold;
    font-weight: 600;
  }

  .list {
    padding: 10px 0;
    width: 650px;

    li {
      padding: 10px 0;
      color: #999999;
      height: 32px;
      line-height: 32px;

      span {
        display: inline-block;
        font-size: 14px;

        &.title {
          width: 100px;
        }

        &.has_value {
          color: #333;
        }

        &.no_value {
          color: #999;
        }
      }

      button {
        float: right;
      }
    }
  }
}

#upHeadIMG {
  display: none;
}

.button {
  width: 1.41rem;
  height: 0.4rem;
  line-height: 0.4rem;
  text-align: center;
  font-size: 0.18rem;
  color: #FFFFFF;
  border-radius: 0.08rem;
  margin: 0.4rem 0 0 1.5rem;
  cursor: pointer;
  background: rgb(1, 97, 255);
}

.resetbutton {
  margin: 0.6rem auto;
}

.password-rate-wrap {
  width: 4.5rem;
  margin-top: 0.3rem;
}

.rate-font {
  display: flex;

  > div {
    flex: 1;
    text-align: center;
    font-size: 0.16rem;
  }
}

.password-rate {
  height: 0.1rem;
  background-color: #d5d5d5;
  display: flex;
  margin-top: 0.2rem;

  div {
    flex: 1;
  }

  .week {
    background-color: #ff0000;
  }

  .middle {
    background-color: #fff200;
  }

  .strong {
    background-color: #00a651;
  }
}

.red-tips {
  font-size: 0.14rem;
  color: #ff0000;
  margin-top: 0.1rem;
}

.social {
  width: 2.05rem;
  height: 0.22rem;
  background: url('/static/peopleCenter/social.png') no-repeat;
  background-size: cover;
  margin-top: 0.45rem;
}

.contain {
  /* display: flex;
  justify-content: space-between; */
  margin-top: 0.4rem;

  .font {
    float: left;
    display: inline-block;
    width: 100px;
    font-size: 14px;
    height: 32px;
    line-height: 32px;
    color: #999;
    text-align: right;
    margin-right: 20px;
  }

  .tips {
    color: #D0021B;
    font-size: 0.16rem;
    font-weight: bold;
  }

  .linkItem {
    margin-bottom: 20px;

    .linkInput {
      width: 9.67rem;
    }

    .linkTitle {
      display: inline-block;
      width: 1rem;
      color: #999;
      padding-left: 0.05rem;
      font-size: 0.16rem;
    }
  }

  input[type='text'], select, textarea {
    width: 4.5rem;
    height: 32px;
    background: rgba(255, 255, 255, 1);
    border-radius: 4px;
    text-indent: 0.1rem;
    outline: none;
    border: 1px solid rgba(0, 0, 0, 0.15);
    font-size: 14px;
    box-sizing: border-box;
  }

  input[type='radio'] {
    width: 16px;
    height: 16px;
  }

  .sexchecked {
    height: 32px;
  }

  .sexchecked span {
  }

  .error {
    border: 1px solid red;
  }

  .peopleDT {
    width: 590px;
    height: 32px;
    text-indent: 0.1rem;
    border-radius: 4px;
    background-color: #fff;
    border: 1px solid rgba(0, 0, 0, 0.15);
    box-sizing: border-box;
  }

  .userJD {
    height: 88px;
  }
}
.cancellation{
  height: 64px;
  border-top: 1px solid #e3e3e3;
  padding: 38px 30px 0;
}
.cancellation .butBox{
  height: 24px;
  line-height: 24px;
  font-size: 16px;
  font-weight: 400;
  color: #2026CC;
  cursor: pointer;
  text-align: right;
}
.cancellation .butBox img{
  width: 18px;
  height: 18px;
}
#area {
  display: block;
  width: 1.22rem;
}

.city {
  display: block;
}

// width: 3.08rem;
// margin-left: 0.2rem;
.resetW {
  width: 14.79rem;
}

.reset-contain {
  justify-content: flex-start;

  .reset-button {
    width: 1.35rem;
    height: 0.5rem;
    line-height: 0.5rem;
    margin: 0.1rem 0 0 0.2rem;
  }
}

.message-top {
  font-size: 0.2rem;
  font-weight: bold;
  padding: 0.8rem 0 0.32rem;
  border-bottom: 2px solid #dddddd;
}

.content {
  width: 1001.74px;
  // background-color: #ffffff;
  padding: 20px 0;
  border-radius: 0.08rem;

  .top-choose {
    width: 100%;
    height: 43.33px;
    font-size: 18px;
    color: #707070;
    box-sizing: border-box;

    > div {
      float: left;
      height: 43.33px;
      color: #999;
      cursor: pointer;
      margin-right: 40px;
      box-sizing: border-box;
    }

    .choose {
      color: #333333;
      font-weight: bold;
    }
  }
}

.body {
  background: #FAFAFA;
}

.container {
  width: 1110px;
  padding: 40px 0 120px 0;
  display: flex;
  margin: 0 auto;
  background: #FAFAFA;
}

.head-name {
  font-size: 0.2rem;
  font-weight: bold;
  padding: 0.48rem 0 0.32rem;
  /* border-bottom: 2px solid #ddd; */
}

.headIMG {
  margin-top: 0.4rem;
  display: flex;
  font-size: 0.2rem;
  color: #000000;
  align-items: flex-end;
  overflow: hidden;

  .big-img-wrap {
    margin-left: 0.8rem;
    margin-top: 1.65rem;

    .big-img {
      display: block;
      width: 1.85rem;
      height: 1.85rem;
      border-radius: 1rem;
      margin: 0.11rem auto 0.21rem;
      border-radius: 100px;
      border: 1px solid #999;
      overflow: hidden;

      img {
        width: 100%;
        height: 100%;
      }
    }
  }

  .small-img-wrap {
    margin-left: 0.9rem;
    margin-top: 1.65rem;
  }

  > div {
    align-self: center;
  }

  .head-own {
    width: 3.7rem;
    height: 3.7rem;
  }

  .re-choose {
    cursor: pointer;
    width: 0.86rem;
    height: 0.3rem;
    text-align: center;
    margin: 0.2rem auto 0;
    padding-bottom: 0.05rem;
    border-bottom: 1px solid #0060ff;
    font-size: 0.2rem;
    color: #0060ff;
  }

  .small-img {
    display: block;
    width: 0.82rem;
    height: 0.82rem;
    margin: 1.13rem auto 0.21rem;
    border-radius: 100px;
    border: 1px solid #999;
    overflow: hidden;

    img {
      width: 100%;
      height: 100%;
    }
  }
}
</style>
<style>
.containerManageCenter .el-input__inner {
  width: 4.56rem;
  height: 0.56rem;
  margin-top: 0.1rem;
  background-color: #f9f9f9;
  border-radius: 0.08rem;
  text-indent: 0.1rem;
  outline: none;
  padding-left: 0;
  color: #333;
  font-size: 0.18rem;
  border: 1px solid #eee;
}

.containerManageCenter .el-input__suffix-inner {
  position: relative;
}
.containerManageCenter .el-input__suffix-inner .el-select__caret {
  position: relative;
  top: 3px;
}
.containerManageCenter .el-input__suffix-inner .is-reverse {
  position: relative;
  top: -5px;
}
.containerManageCenter .error {
  border: 1px solid red;
}

.containerManageCenter .el-date-editor.el-input {
  width: auto;
}

.containerManageCenter .el-input__prefix {
  top: 0.05rem;
}
.headview,
.modify-password-content {
  padding: 0 30px;
  background: #ffffff;
  /* border: 1px solid #e0e0e0; */
}
.endcroping img {
  width: 108px;
  height: 108px;
  border-radius: 50%;
  margin-top: 5px;
}
.userinformation {
  position: relative;
  color: #333;
  font-size: 14px;
  font-weight: bold;
  margin: 40px 0 20px 0;
}
.inforsub {
  position: absolute;
  top: 0;
  right: 0;
  display: block;
  width: 76px;
  height: 30px;
  text-align: center;
  line-height: 30px;
  color: #fff;
  cursor: pointer;
  background: #2026cc;
}
.userbirthday .el-input__inner,
.special .el-input__inner {
  width: 4.5rem;
  height: 32px;
  margin-top: 0;
  border-radius: 4px;
  background-color: #fff;
  border: 1px solid rgba(0, 0, 0, 0.15);
  box-sizing: border-box;
}
.userbirthday .el-input__prefix {
  top: -3px;
  display: none;
}
.userbirthday .el-input__suffix-inner {
  top: -2px;
}
.bindstyle {
  height: 32px;
  line-height: 32px;
}
.contain .bindstyle input[readonly] {
  background: rgba(204, 204, 204, 0.1);
  border: 0;
}
.bindstyle a {
  color: #2026cc;
  margin-right: 10px;
  cursor: pointer;
}
.bindstyle span {
  color: #ccc;
}
.bindstyle p {
  font-size: 16px;
}
.userstyle {
  overflow: hidden;
  box-sizing: border-box;
}
.userstyle span {
  display: inline-block;
  float: left;
  height: 32px;
  font-size: 14px;
  color: #666666;
  line-height: 32px;
  padding: 0 12px;
  cursor: pointer;
  margin: 0 10px 10px 0;
  background: #f5f5f5;
  box-sizing: border-box;
}
.userstyle span.active {
  color: #ffffff;
  height: 32px;
  background: #2026cc;
  box-sizing: border-box;
}
.clickaddtitle {
  display: inline-block;
  float: left;
  width: 70px;
  height: 32px;
  cursor: pointer;
  text-align: center;
  color: #999;
  margin: 0 10px 10px 0;
  line-height: 32px;
  font-size: 14px;
  border: 1px solid #ccd0d7;
  background: #f3f3f3;
}
.basic-message .padd30 {
  padding: 0 30px;
}
.bordertps {
  margin-top: 40px;
  padding-top: 40px;
  border-top: 1px solid #e3e3e3;
}
.bordertps .left {
  padding: 0 30px;
}
.educations .userinformation {
  margin: 0 0 20px 0;
}
.educations > div {
  padding: 0 30px;
}
.contain select.selchecked {
  width: 133px;
  color: #999;
  margin-left: 8px;
}
.wecharcode {
  margin-bottom: 20px;
}
div.mt30 {
  margin-top: 20px !important;
}
div.mt20 {
  margin-top: 20px;
}
/*sex checked*/
input[type="radio"] {
  position: absolute;
  clip: rect(0, 0, 0, 0);
}
input[type="radio"] + label {
  position: relative;
  top: 4px;
}
#womensex + label {
  margin-left: 30px;
}
input[type="radio"]:checked + label::before {
  background-color: #2026cc;
  background-clip: content-box;
  padding: 2px;
  border: 1px solid #2026cc;
}
input[type="radio"] + label::before {
  content: "\A0";
  display: inline-block;
  vertical-align: middle;
  font-size: 18px;
  width: 16px;
  height: 16px;
  margin-right: 0.4em;
  border-radius: 50%;
  border: 1px solid #d9d9d9;
  text-indent: 0.15em;
  line-height: 1;
  cursor: pointer;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
.userinfortit {
  position: relative;
  float: left;
  width: 150px;
  height: 32px;
}

.userinfortit input[type="text"] {
  float: left;
  width: 100px !important;
  height: 32px !important;
  font-size: 14px;
  padding-left: 10px;
  background-color: #f3f3f3;
  border-radius: 16px 0 0 16px !important;
  box-sizing: border-box;
}

.userinfortit a {
  float: left;
  width: 50px;
  height: 32px;
  color: #fff;
  cursor: pointer;
  text-align: center;
  line-height: 32px;
  font-size: 14px;
  border-radius: 0 16px 16px 0;
  background-color: #2026cc;
}
.upcontent1 {
  position: relative;
}
.upcontent1 .change {
  position: absolute;
  top: 118px;
  left: 50%;
  margin-left: -2.4%;
}

textarea::-webkit-input-placeholder {
  /* WebKit, Blink, Edge */
  color: #ccc;
}
textarea:-moz-placeholder {
  /* Mozilla Firefox 4 to 18 */
  color: #ccc;
}
textarea::-moz-placeholder {
  /* Mozilla Firefox 19+ */
  color: #ccc;
}
textarea:-ms-input-placeholder {
  /* Internet Explorer 10-11 */
  color: #ccc;
}
</style>



// WEBPACK FOOTER //
// src/pages/my/account/manageCenter.vue